import ElegantTabs from './ElegantTabs';

export default ElegantTabs;
